<div class="p-field-checkbox">
  <p-checkbox
    [name]="field.key"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [inputId]="field.id"
    [id]="field.key"
    [styleClass]="props.mini ? 'p-mini-checkbox' : props.styleClass"
    [binary]="true"
  ></p-checkbox>
  <label
    *ngIf="to.label"
    [for]="field.id"
    class="b-f-checkbox-label"
    [ngClass]="props.mini ? 'basin-font-size-10' : ''"
    >{{ to.label
    }}<span *ngIf="props.required"> {{ props.required ? '&nbsp;*' : '' }} </span
    ><span
      class="b-f-checkbox-icon {{ props.iconClass }}"
      [ngClass]="props.mini ? ' basin-ml-1' : ''"
    ></span>
  </label>
  <div
    *ngIf="props.tooltip"
    class="symbol-info tooltip-icon"
    [pTooltip]="props.tooltip"
  ></div>
</div>
